import { render, staticRenderFns } from "./ContratsClient.vue?vue&type=template&id=f850c184"
import script from "./ContratsClient.vue?vue&type=script&lang=js"
export * from "./ContratsClient.vue?vue&type=script&lang=js"
import style0 from "./ContratsClient.vue?vue&type=style&index=0&id=f850c184&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports